import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var CheckLinear = function CheckLinear(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.663 4.627c.38.36.39.964.02 1.336l-5.444 5.464a1 1 0 01-1.358 0L3.34 8.962a.932.932 0 111.3-1.336L6.56 9.5l4.799-4.852a.933.933 0 011.304-.021z",
    fill: "currentColor"
  }));
};
export default CheckLinear;